import { supabase } from '@/integrations/supabase/client';

/**
 * The run-observability spine tables (workflow_run / workflow_run_step) are created by the Phase 0/1
 * migrations and are NOT yet in the generated Database types, so the typed `supabase.from()` overload
 * rejects them. Read them via an untyped handle — RLS still scopes every read to the caller's tenant
 * (the `*_tenant_read` policies), and we cast the result rows to our hand-written types at the hook.
 *
 * NOTE: always query the PARENT table (workflow_run / workflow_run_step) — the monthly partition
 * CHILDREN have no `authenticated` grant (G7 hardening); Postgres routes parent SELECTs to children
 * under the parent RLS.
 */
export function runObsFrom(table: 'workflow_run' | 'workflow_run_step') {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- tables absent from generated types; RLS-scoped read
  return (supabase as any).from(table);
}
